import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { initSentry } from './app/core/config/sentry.config';

// Suppress Mapbox GL JS worker error caused by esbuild stripping __async helper
// from the worker bundle context (async generator transpilation issue, no user impact)
window.addEventListener(
    'error',
    (event) => {
        if (event.message === '__async is not defined' || event.message?.includes('syncRTLPluginState')) {
            event.preventDefault();
        }
    },
    true,
);

// Enable production mode if the application is running in a production environment
if (environment.production) {
    enableProdMode();
}

// Initialize Sentry for error tracking and monitoring
initSentry();

bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) =>
    console.error(err),
);
